export type PracticeMode = "training" | "simulation";

export const ATSA_PROFILE_2026 = {
  totalActiveSeconds: 2 * 60 * 60 + 49 * 60,
  totalBreakSeconds: 30 * 60,
  memory: {
    rounds: 8,
    roundSeconds: 90,
    firstDigitMs: 2000,
    digits: [1, 2, 3, 4, 5, 6, 7, 8, 9] as const,
  },
  values: {
    parts: 3,
    setsPerPart: 10,
    displayMs: 1750,
    gapMs: 250,
    minValue: 1,
    maxValue: 4,
  },
  spatial: {
    parts: 2,
    questionsPerPart: 30,
    responseWindowMs: 1750,
    eyeProbability: 0.45,
  },
  radar: {
    parts: 2,
    secondsPerPart: 10 * 60,
    minTargets: 2,
    maxTargets: 7,
    mathVisibleMs: 2800,
    mathIntervalMinMs: 4200,
    mathIntervalMaxMs: 8500,
    collisionFlashMs: 180,
  },
  personality: {
    triads: 108,
    triadsPerPage: 2,
  },
  reading: {
    passages: 6,
    questionsPerPassage: 3,
    seconds: 15 * 60,
  },
  logic: {
    questions: 15,
    seconds: 20 * 60,
    allowBacktracking: false,
  },
} as const;

export const EVIDENCE_NOTES = {
  official: [
    "Maximum active testing time: 2 hours 49 minutes.",
    "Maximum break allowance: 30 minutes.",
  ],
  highConfidence: [
    "Seven reported sections.",
    "Spatial responses use T and F.",
    "Radar removals use the numeric keypad and math uses A/S/D/F.",
    "Personality uses forced-choice triads.",
  ],
  configurable: [
    "Memory round length: 90 or 120 seconds.",
    "Reading limit: 15 or 20 minutes.",
    "Logic count: 15 or approximately 18 items.",
    "Radar zero-key rule.",
  ],
} as const;
